import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TaskBoardAsyncPipe } from './task-board-async.pipe';

@NgModule({
  declarations: [TaskBoardAsyncPipe],
  imports: [CommonModule],
  exports: [TaskBoardAsyncPipe],
  providers: [TaskBoardAsyncPipe]
})
export class TaskBoardAsyncModule { }
